/*Auraplusclo*/
/**
 * 
 * navigation-drawer.js
 * Scuffers Navigation Drawer – Vanilla JS Controller
 *
 * Einbinden im header.liquid (vor </body> oder im <head> mit defer):
 *   <script src="{{ 'navigation-drawer.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  /* ── Selectors ─────────────────────────────────────────── */
  const DRAWER_ID    = 'scuffers-nav-drawer';
  const OVERLAY_ID   = 'nav-drawer-overlay';
  const CLOSE_ID     = 'nav-drawer-close';
  const OPEN_TRIGGER = '[id="nav-drawer-open"], [aria-controls="' + DRAWER_ID + '"]';

  /* ── State ─────────────────────────────────────────────── */
  let drawer   = null;
  let overlay  = null;
  let focusTrap = null;

  /* ── Init ──────────────────────────────────────────────── */
  function init() {
    drawer  = document.getElementById(DRAWER_ID);
    overlay = document.getElementById(OVERLAY_ID);

    if (!drawer) return;

    // Open triggers (hamburger button in header)
    document.querySelectorAll(OPEN_TRIGGER).forEach(function (btn) {
      btn.addEventListener('click', openDrawer);
    });

    // Close button inside drawer
    var closeBtn = document.getElementById(CLOSE_ID);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Overlay click
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    // Tab switching
    drawer.querySelectorAll('.nav-drawer__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchTab(tab.dataset.tab);
      });
    });

    // Accordion triggers
    drawer.querySelectorAll('.nav-drawer__accordion-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        toggleAccordion(trigger);
      });
    });
  }

  /* ── Open / Close ──────────────────────────────────────── */
  function openDrawer() {
  if (!drawer) return;
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('is-visible');

  // Prestige-kompatibler Scroll-Lock
  document.documentElement.classList.add('no-scroll');
  document.body.style.overflow = 'hidden';
}

function closeDrawer() {
  if (!drawer) return;
  drawer.classList.remove('is-open');
  drawer.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.classList.remove('is-visible');

  // Scroll-Lock aufheben
  document.documentElement.classList.remove('no-scroll');
  document.body.style.overflow = '';
}

  /* ── Tab Switching ─────────────────────────────────────── */
  function switchTab(tabId) {
    if (!drawer) return;

    // Update tab buttons
    drawer.querySelectorAll('.nav-drawer__tab').forEach(function (tab) {
      var isActive = tab.dataset.tab === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    // Update panels
    drawer.querySelectorAll('.nav-drawer__panel').forEach(function (panel) {
      panel.classList.remove('is-active');
    });

    var activePanel = document.getElementById('nav-panel-' + tabId);
    if (activePanel) {
      activePanel.classList.add('is-active');
    }
  }

  /* ── Accordion ─────────────────────────────────────────── */
  function toggleAccordion(trigger) {
    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    var body = trigger.nextElementSibling;

    trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');

    if (body) {
      body.classList.toggle('is-open', !isExpanded);
    }
  }

  /* ── Run ───────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose public API for Shopify theme customizer
  window.NavigationDrawer = {
    open:  openDrawer,
    close: closeDrawer,
  };

})();